import useEffectOnce from './useEffectOnce';

export default function useWindowResize(onResizeCallback) {
    useEffectOnce(() => {
        window.addEventListener('resize', onResizeCallback, false);
        return () => window.removeEventListener('resize', onResizeCallback, true);
    });
}
